import templateUrl from './json.tpl.html';

angular
    .module('festzelt-os.components')
    .component('filterJson', {
        bindings: {
            store: '<',
            col: '<',
        },
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/components/state-manager/filter-field/types/filter-type-json.js